import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  :root {
    --primary: #722ED1;
    --gray-50: #f0f0f0;
    --gray-100: #E5E5E5;
    --gray-200: #909090;
    --success: #03b14e;
    --info: #0071c0;
    --danger: #ff0a02;
    --white: #FFF;
    --blue-100: #2aa1ff;
    --warning: #ff8c00;
  }

  body {
    font-family: 'Roboto', sans-serif;
  }

  ul {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  a:active,
  a:focus,
  a:hover {
    color: inherit;
  }
`;
